import { fetcher } from '@bino/utils/fetcher';
import { I18nProvider } from '@bino/utils/i18next';
import type { ReactNode } from 'react';
import { SWRConfig } from 'swr';

import GlobalCartError from './components/globalCartError/globalCartError';
import type { ShoppingCartProviderProps } from './context/CartContext';
import { ShoppingCartProvider } from './context/CartContext';
import { i18n } from './i18n';

export type CartWrapperProps = {
    children: ReactNode;
    props: Omit<ShoppingCartProviderProps, 'children'>;
};

export const CartWrapper = ({ children, props }: CartWrapperProps) => {
    return (
        <I18nProvider i18n={i18n}>
            <SWRConfig
                value={{
                    revalidateOnMount: true,
                    revalidateOnFocus: true,
                    revalidateOnReconnect: true,
                    fetcher: fetcher.get,
                }}
            >
                <ShoppingCartProvider {...props}>
                    {children}
                    <GlobalCartError />
                </ShoppingCartProvider>
            </SWRConfig>
        </I18nProvider>
    );
};
